import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsgInfoService } from '../services/msg-info.service';

@Injectable({ providedIn: 'root' })
export class OfflineSyncService {

  constructor(
    private http: HttpClient,
    private msgInfo: MsgInfoService
  ) {}

  async synchroniserAppels() {
    const stored = JSON.parse(localStorage.getItem('offline-calls') || '[]');
    if (!stored.length) return;

    this.msgInfo.updateInfo({ msg: `🔄 Synchronisation des appels...`, duration: 3000 });

    const ordre = ['begin', 'ls', 'end'];
    stored.sort((a: any, b: any) => ordre.indexOf(a.type) - ordre.indexOf(b.type));

    for (const req of stored) {
      try {
        await this.http.request(req.method, req.url, { body: req.body, headers: req.headers }).toPromise();
      } catch (error) {
        this.msgInfo.updateInfo({ msg: `❌ Échec lors de la synchronisation. Nouvel essai plus tard.`, duration: 5000 });
        return;
      }
    }

    localStorage.removeItem('offline-calls');
    this.msgInfo.updateInfo({ msg: `✅ Synchronisation terminée`, duration: 4000 });
  }
}

